module.exports = {
  __depends__: [
    require(147),
    require(149),
    require(159)
  ],
  bpmnReplace: [ 'type', require(37) ]
};